import { useEffect } from "react";
import { POLICIES } from "@/lib/content";
import { FadeUp } from "@/components/Reveal";

export default function Policy({ id }) {
  const policy = POLICIES[id];

  useEffect(() => {
    document.title = `${policy.title} — REQUIEM FEVER`;
  }, [policy]);

  return (
    <div className="bg-ink" data-testid={`policy-${id}-page`}>
      <div className="mx-auto max-w-3xl px-5 py-14 sm:px-8 sm:py-20">
        <FadeUp>
          <h1 className="font-display text-5xl leading-[0.9] tracking-[0.01em] text-bone sm:text-6xl">
            {policy.title}
          </h1>
        </FadeUp>
        <div className="mt-12 space-y-10">
          {policy.sections.map((s, i) => (
            <FadeUp key={s.h} delay={i * 0.06}>
              <div className="border-l-2 border-violet/60 pl-6">
                <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">{s.h}</h2>
                <p className="mt-3 text-sm leading-relaxed text-bone/70">{s.p}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
}
